import { SessionData, RuleValidationData } from '../../utils/StandardReducer'

export const EMPTY_SESSION: SessionData = {
  additionalCarrierProtein: 'None',
  additionalComments: '',
  additionalServices: [],
  amount: '',
  applyToAll: false,
  autoValidation: '',
  baseCount: 0,
  carrierProtein: '',
  cartId: '',
  comments: '',
  concentration: '',
  conjugation: 'None',
  conjugationAmount: '',
  conjugationChemistry: '',
  countryCode: '',
  crossContamination: '',
  crRnaType: '',
  cterminalMod: '',
  currency: '',
  currencySymbol: '',
  customPeptideType: '',
  epsilon: 0,
  fiveMod: '',
  fiveModCategory: '',
  flag: 0,
  format: 'DRY',
  fullSOligoBackbone: false,
  gcContent: '',
  id: '1',
  internalMod: '',
  internalModCategory: '',
  isLabelledAminoAcid: true,
  isoCode: false,
  isOverridden: false,
  itemId: '',
  listError: [
    {
      key: '',
      value: '',
    },
  ],
  material: '',
  meltingTemparature: '',
  minimumYield: '',
  molecularWeight: '',
  name: '',
  nterminalMod: '',
  oligoId: 1,
  orderItemId: '',
  otherValue: '',
  packageType: '',
  plateType: '',
  price: '',
  primerDimer: '',
  probeType: '',
  productType: '',
  purification: '',
  purityLevel: '',
  quantitation: '',
  scale: '',
  secondaryStructure: '',
  sequence: '',
  sequenceLocation: '',
  threeMod: '',
  threeModCategory: '',
  tubes: '1',
}

export const EMPTY_ERROR_DATA: RuleValidationData = {
  name: '',
  sequence: '',
  scale: '',
  purification: '',
  fiveMod: '',
  threeMod: '',
  researcher: '',
  format: 'DRY',
  concentration: '',
  tubes: '1',
  countryCode: '',
  fullSOligoBackbone: false,
  isOverridden: false,
  comments: '',
  cterminalMod: '',
  nterminalMod: '',
  otherValue: '',
  amount: '',
  isLabelledAminoAcid: true,
  quantitation: '',
  purityLevel: '',
  conjugation: 'None',
  conjugationAmount: '',
  conjugationChemistry: '',
  additionalCarrierProtein: 'None',
  additionalServices: [],
  flag: 0,
  internalMod: '',
  probeType: '',
}
